/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useContext } from 'react'
import CaseReviewScreenPopup from '../CaseReviewScreenPopup/casereviewscreenpopup'
import Table from 'react-bootstrap/Table'
import { getGridSearchData } from '../../../common/apiService'
import { UserContext } from '../../../contexts/UserContext';
import { toast } from 'react-toastify';
import Moment from 'moment'
import Loader from 'react-loader-spinner';



export default function SearchListingPage({ location }) {
    const userDetail = useContext(UserContext);
    const [showCaseReviewPopup, setShowCaseReviewPopup] = useState(false);
    const [currentViolationIndex, setCurrentViolationIndex] = useState("0");
    const [searTxt, setSearTxt] = useState("");
    const [loading, setLoading] = useState(false);

    // const [searchtext, setSearchText] = useState('');
    const [gridList, setGridList] = useState([]);

    const headerJson = {
        plazaId: userDetail.plaza
    }

    useEffect(() => {
        if (location.state) {
            if(userDetail?.plaza!==null && userDetail?.plaza!==""){
                getGridData(location.state.searchtext,location.state.searchType)
                setSearTxt(location.state.searchtext);
            }
        }
    }, [userDetail,location])

    const getGridData = (searchtext,searchType) => {
        setLoading(true);
        console.log("search type ",searchType);
        const jsonData = {
            plazaId: Array.isArray(userDetail.plaza) ? userDetail.plaza.join(",") : userDetail.plaza
        };        
        getGridSearchData(searchtext,searchType,jsonData).then(res => {
            if (res.data && res.data !== "No record Found!")
                setGridList(res.data);
            else
                setGridList([])
            setLoading(false);
        }).catch(err => {
            setGridList([])
            if (err.response.status === 404);
            toast.warn("Server not found!");
            setLoading(false);
        })
    }

    return (

        <>
            <Loader className="loader"
                type="ThreeDots"
                color="#9c1d26"
                height={100}
                width={100}
                visible={loading} />
          {showCaseReviewPopup && <CaseReviewScreenPopup
                showModel={showCaseReviewPopup}
                setShowModel={setShowCaseReviewPopup}
                parentGridData={gridList}
                setParentGridData={() => { }}
                violationtype=""
                index={currentViolationIndex}
                setCurrentPage={() => { }}
                currentPage={0}
                totalPage={1}
                actionperform={false}
            /> 
          }
            <div className="container-fluid">
                <div className="col-md-12">
                    {searTxt && <h4 className="lowh3" style={{ color: 'black' }}>Search result for <b>'{searTxt}'</b></h4>}
                    <br />
                    <Table variant="light" className="customTable searchGridTable">
                        <thead>
                            <tr className="pointer">
                                <th>RRN</th>
                                <th>Toll Plaza ID</th>
                                <th>Tag ID</th>
                                <th>Reg Number</th>
                                <th>Txn Status</th>
                                <th>Processing Time</th>
                                <th>Mapped AVC</th>
                                <th>NPCI VC</th>
                                <th>Error code</th>
                            </tr>
                        </thead>
                        <tbody>
                            {gridList.length > 0 ?
                                gridList.map((e, index) => {
                                    return (
                                        <tr className="pointer" onClick={() => { setShowCaseReviewPopup(true); setCurrentViolationIndex(index) }}>
                                            <td><b>{e.rrn}</b></td>
                                            <td>{e.plazaId}</td>
                                            <td>{e.tagId}</td>
                                            <td>{e.regNumber}</td>
                                            <td>{e.transactionStatus}</td>
                                            <td>{Moment.utc(e.processingTime).format("DD.MM.yyyy, hh:mm A")}</td>
                                            <td>{e.mappedAvc}</td>
                                            <td>{e.npciVehicleClass}</td>
                                            <td>{e.errorCode}</td>
                                        </tr>
                                    )
                                })
                                :
                                <tr>
                                    {!loading &&<td colSpan="8" style={{ textAlign: 'center' }}>Data Not Found!</td>}
                                </tr>
                            }

                        </tbody>
                    </Table>
                </div>
            </div>
        </>
    )
}
